export default __webpack_public_path__ + "media/eduJessieErickson.7584f72b.jpg";